// Stream SDK errors can carry participant display names / call ids, and PostHog
// autocaptures console.error verbatim — only the error type may cross.
function safeShape(error: unknown) {
  return { name: error instanceof Error ? error.name : 'UnknownError' };
}

export function logVideoError(operation: string, error: unknown): void {
  console.error(`Failed to ${operation}:`, safeShape(error));
}

// console.warn is not autocaptured, so nothing logged here reaches PostHog.
// Only for failures that are expected on some browsers and are not defects.
export function logVideoWarning(operation: string, error: unknown): void {
  console.warn(`Failed to ${operation}:`, safeShape(error));
}
